module.exports = __webpack_public_path__ + "static/banner-image-68bcff7f055493f4b41cf77c9b68ac23.png";